import { Component, OnInit } from '@angular/core';
import { MessageLogService } from 'app/integration/message-log/services/message-log.service';
import { LogSearchParams, MessageLog, Participant, Service } from 'app/integration/message-log/services/message-log';
import { SearchResult } from '@heda/core-util';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentStateStore } from '@heda/core-util';
import { TranslateService } from '@ngx-translate/core';
import { PrintoutGenerationService } from 'app/sauron/printout/services/printout-generation.service';

@Component({
  templateUrl: './log-list.component.html',
})
export class LogListComponent implements OnInit {
  logs: SearchResult<MessageLog>;
  services: Array<Service>;
  participants: Array<Participant>;
  params: LogSearchParams = new LogSearchParams();
  resource: string;
  resourceId: string;
  loading: boolean;
  private STORE_KEY = 'log-list';
  private REPORT_CODE = 'integration.log.report';

  constructor(
    private logService: MessageLogService,
    private stateStore: ComponentStateStore,
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private printoutGenerationService: PrintoutGenerationService
  ) {}

  ngOnInit(): void {
    this.setDefaultParams();

    const state = this.stateStore.pop(this.STORE_KEY);
    if (state && this.route.snapshot.paramMap.keys.length === 0) {
      this.params = state.params;
    }

    if (this.route.snapshot.paramMap.has('resource')) {
      const resourcePipe = this.route.snapshot.paramMap.get('resource');
      if (resourcePipe.indexOf('|') !== -1) {
        this.setResource(resourcePipe);
        this.params.reference = resourcePipe;
      }
    } else if (this.params.reference) {
      this.setResource(this.params.reference);
    }

    if (this.route.snapshot.paramMap.has('service')) {
      this.params.service = this.route.snapshot.paramMap.get('service');
    }

    if (this.route.snapshot.paramMap.has('messageId')) {
      this.params.messageId = this.route.snapshot.paramMap.get('messageId');
      this.params.dateFrom = null;
      this.params.dateTo = null;
    }

    this.getLogs();
    this.getServices();
    this.getParticipants();
  }

  private setResource(resourcePipe: string) {
    const pipe = resourcePipe.split('|');
    this.resource = pipe[0];
    this.resourceId = pipe[1];
  }

  private setDefaultParams() {
    this.params = new LogSearchParams();
    this.params.sort = '-date';
    this.params.dateFrom = moment().startOf('day').toDate();
    this.params.dateTo = moment().endOf('day').toDate();

    this.resourceId = null;
    this.resource = null;
  }

  getLogs(): void {
    this.stateStore.put(this.STORE_KEY, { params: this.params });
    if (this.resource && this.resourceId) {
      this.params.reference = this.resource + '|' + this.resourceId;
    }
    this.loading = true;
    this.logService.query(this.params).subscribe((resp) => {
      this.loading = false;
      this.logs = resp;
    });
  }

  emptyFilter(): void {
    this.setDefaultParams();
    this.router.navigate(['/integration/logs']);
  }

  private getServices(): void {
    this.logService.getServices().subscribe((resp) => (this.services = resp));
  }

  private getParticipants(): void {
    this.logService.getParticipants().subscribe((resp) => (this.participants = resp));
  }

  public search(): void {
    this.params.offset = 0;
    this.getLogs();
  }

  public printLogReport(): void {
    const params = {
      dateFrom: this.params.dateFrom,
      dateTo: this.params.dateTo,
      status: this.params.status,
      service: this.params.service,
      lang: this.translateService.currentLang,
    };
    this.printoutGenerationService.configuredPrint(this.REPORT_CODE, params).subscribe();
  }
}
